import { hdrm } from '@yola/ws-sdk';

const { updateStrategies } = hdrm.constants;

export const DEFAULT_OPTIONS = {
  strategy: updateStrategies.UPDATE_BOTH,
};
